import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connectModal } from 'redux-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'react-bootstrap-button-loader';
import { connect } from 'react-redux';
import { AdvertiserApi } from '../../../api';
import { validateCSVUpload, validateXLSXUpload, validateXMLUpload } from '../../../utils/helpers/job_validators';
import { setLoader, removeLoader } from '../../../actions';
import UploadPreview from './UploadPreview';

class UploadPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileIsValid: null,
      tooLarge: null,
      result: [],
      missingFields: [],
      missing: [],
      loading: 0,
      type: '',
      fileName: '',
    };
  }

  handleJobsUpload(e) {
    const { dispatch, account, handleHide } = this.props;
    e.preventDefault();
    const data = Array.isArray(this.state.result) ? this.state.result : [this.state.result];
    const params = { account_id: account.uuid };
    dispatch(setLoader('JobUploadPop'));
    this.setState({ loading: 2 });
    if (this.state.fileIsValid) {
      dispatch(
        AdvertiserApi.actions.bulkJobsCreate.post(params, { jobs: data }, (_error, success) => {
          dispatch(removeLoader('JobUploadPop'));
          if (success) {
            this.setState({ loading: 0 });
            handleHide();
            dispatch(AdvertiserApi.actions.jobs.get(params));
          } else {
            this.setState({ loading: 0 });
          }
        }),
      );
    }
  }

  isFileValid() {
    if (this.state.missing && this.state.missingFields) {
      return this.state.missing.length || this.state.missingFields.length
        ? this.setState({ fileIsValid: false })
        : this.setState({ fileIsValid: true });
    }
    return this.setState({ fileIsValid: true });
  }

  handleFileChange(e) {
    e.preventDefault();
    this.setState({ loading: 1, fileIsValid: null });
    const reader = new FileReader();
    const file = e.target.files[0] || 0;
    const getSize = size => {
      if (size / 6000000 > 1) {
        this.setState({ tooLarge: true });
      } else {
        this.setState({ tooLarge: false });
      }
      return size / 6000000 < 1 && size > 0 ? true : false;
    };
    const getFileType = fileName => {
      // this function uses a substring instead of file.type
      // mainly because the many variations that .type on an
      // xlsx can generate lots of stuff that isnt "xlsx"
      return fileName.name.substring(file.name.length - 4, file.name.length);
    };

    const scope = this;
    if (getSize(file.size)) {
      scope.setState({ fileName: file.name });
      switch (getFileType(file)) {
        case '.xml':
          reader.onload = () => {
            const xmlUpload = reader.result;
            // if valid xml, returns array of job jsons, if not returns array with array of missing fields + jobs with missing fields
            const result = validateXMLUpload(xmlUpload);
            if (result.missing) {
              scope.setState({ ...result, type: 'xml' });
            } else {
              scope.setState({ result, type: 'xml', missing: [], missingFields: [] });
            }
            this.isFileValid();
          };
          reader.readAsText(file);
          break;
        case '.csv':
          return new Promise((resolve, _reject) => {
            reader.onload = () => {
              resolve(reader.result);
            };
            reader.readAsText(file);
          }).then(val => {
            return validateCSVUpload(val).then(result => {
              if (result.missing) {
                scope.setState({ ...result, type: 'csv' });
                this.isFileValid();
                scope.setState({ loading: 0 });
                return scope;
              }
              scope.setState({ result, type: 'csv', missing: [], missingFields: [] });
              this.isFileValid();
              scope.setState({ loading: 0 });
              return scope;
            });
          });
        case 'xlsx':
          reader.onload = () => {
            const xlsxUpload = reader.result;
            const result = validateXLSXUpload(xlsxUpload);
            if (result.missing) {
              scope.setState({ ...result, type: 'xlsx' });
            } else {
              scope.setState({ result, type: 'xlsx', missing: [], missingFields: [] });
            }
            this.isFileValid();
          };
          reader.readAsBinaryString(file);
          break;
        default:
          this.setState({ fileIsValid: false });
          break;
      }
    } else {
      this.setState({ fileIsValid: false });
    }
    scope.setState({ loading: 0 });
  }

  feedFieldsExample() {
    return (
      <pre>
        <table>
          <thead>
            <tr>
              <th className="fields">title</th>
              <th className="fields">date</th>
              <th className="fields">url</th>
              <th className="fields">company</th>
              <th className="fields">city</th>
              <th className="fields">state</th>
              <th className="fields">country</th>
              <th className="fields">category</th>
              <th className="fields">description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fields">Example Job Title</td>
              <td className="fields">2020/01/22</td>
              <td className="fields">http://www.url.com</td>
              <td className="fields">Widgets Inc.</td>
              <td className="fields">Chicago</td>
              <td className="fields">Illinois</td>
              <td className="fields">US</td>
              <td className="fields">Sales</td>
              <td className="fields">Example job description</td>
            </tr>
          </tbody>
        </table>
      </pre>
    );
  }

  renderUploadErrors() {
    if (this.state.missingFields.length && ['csv', 'xlsx'].includes(this.state.type)) {
      const headersMissing = <strong>{this.state.missingFields.join(', ')}</strong>;
      return (
        <div className={'alert alert-danger'}>
          <h4 className="alert-heading">Something went wrong with your upload</h4>
          <br />
          <p>
            Please make sure the first row in your file is a valid header row. Currently these columns are missing:
            <br />
            <br />
            {headersMissing}
          </p>
        </div>
      );
    } else if (this.state.missing.length || (this.state.missingFields.length && this.state.type === 'xml')) {
      return (
        <div className={'alert alert-danger'}>
          <h4 className="alert-heading">Something went wrong with your upload </h4>
          <br />
          <p>
            At least {this.state.missing.length} of the jobs in your file have one or more of the following required fields either blank, missing, or
            invalid.
          </p>
          <br />
          <UploadPreview data={this.state.missing.length > 5 ? this.state.missing.slice(0, 5) : this.state.missing} />
        </div>
      );
    } else {
      return null;
    }
  }

  renderLoading() {
    switch (this.state.loading) {
      case 1:
        return 'Validating...';
      case 2:
        return 'Uploading...';
      default:
        break;
    }
  }

  render() {
    const { show, account, handleHide } = this.props;
    const feedFieldsExample = (
      <pre>
        <table>
          <thead>
            <tr>
              <th className="fields">title</th>
              <th className="fields">date</th>
              <th className="fields">url</th>
              <th className="fields">company</th>
              <th className="fields">city</th>
              <th className="fields">state</th>
              <th className="fields">country</th>
              <th className="fields">category</th>
              <th className="fields">description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fields">Example Job Title</td>
              <td className="fields">2020/01/22</td>
              <td className="fields">http://www.url.com</td>
              <td className="fields">Widgets Inc.</td>
              <td className="fields">Chicago</td>
              <td className="fields">Illinois</td>
              <td className="fields">US</td>
              <td className="fields">Sales</td>
              <td className="fields">Example job description</td>
            </tr>
          </tbody>
        </table>
      </pre>
    );

    const optionalFieldsExample = (
      <pre>
        <table>
          <thead>
            <tr>
              <th className="fields">salary</th>
              <th className="fields">educaction</th>
              <th className="fields">jobtype</th>
              <th className="fields">experience</th>
              <th className="fields">referencenumber</th>
              <th className="fields">postalcode</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="fields">40,000</td>
              <td className="fields">Bachelors</td>
              <td className="fields">Senior</td>
              <td className="fields">5+ years</td>
              <td className="fields">JR-001</td>
              <td className="fields">12345</td>
            </tr>
          </tbody>
        </table>
      </pre>
    );
    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>Account - {account.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.handleJobsUpload.bind(this)}>
            <p>Please select a CSV, XML, XSLX file to upload (6MB limit)</p>
            <h3>
              {' '}
              Uploads <strong>must</strong> contain a header row with the following fields (all jobs must have these fields filled):{' '}
            </h3>
            {feedFieldsExample}
            <h3>Fields below are optional: </h3>
            {optionalFieldsExample}
            <br />
            <span style={{ textAlign: 'center', color: 'gray', marginTop: '15px' }}>
              <div className="alert alert-warning">
                <FontAwesomeIcon icon="info-circle" /> &nbsp; When using XML make sure to wrap fields in a job wrapper ({'<job></job>'}) and all jobs
                in a source wrapper ({'<source></source>'})
              </div>
            </span>
            <div className="box">
              <input
                type="file"
                name="file-input[]"
                id="file-input"
                className="input-file"
                accept=".csv,.xml,.xlsx"
                onChange={this.handleFileChange.bind(this)}
              />
              <label htmlFor="file-input">
                <span className={!this.state.fileName && 'size-prompt'}>{this.state.fileName ? this.state.fileName : 'File must be ≤ 6MB'}</span>
                <strong>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
                    <path
                      // eslint-disable-next-line max-len
                      d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
                    />
                  </svg>
                  &nbsp; Choose a file…
                </strong>
              </label>
              <br />
              <Button bsStyle="primary" bsSize="small" type="submit" loading={this.state.loading > 0} disabled={!this.state.fileIsValid}>
                {this.state.loading ? `${this.renderLoading()}` : 'Add Jobs to Inventory'}
              </Button>
            </div>
            {this.state.tooLarge && (
              <div className="alert alert-danger">
                <div> File must be ≤ 6MB </div>
              </div>
            )}
            <div>
              {this.renderUploadErrors()}
              {this.state.fileIsValid && (
                <div className="alert alert-success">
                  <h4 className="alert-heading">Your file looks like it&apos;s ready to be uploaded</h4>
                </div>
              )}
            </div>
            <br />
            <br />
          </form>
        </Modal.Body>
      </Modal>
    );
  }
}

const UploadJobsPopModal = connectModal({
  name: 'UploadJobsPopModal',
  firstFiveJobs: [],
});
const mapStateToProps = state => {
  const { account, loader } = state;
  return {
    account,
    loader,
  };
};
export default connect(mapStateToProps)(UploadJobsPopModal(UploadPopup));
